import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "./authReducer";
import adminAuth from "./adminReducer";
import categoryReducer from "./categoryReducer";
import manageOptions from "./manageOptionsReducer";
import frontEndUsers from "./frontEndUserReducer";
import misc from "./miscReducer";
import countries from "./countriesReducer";
import settings from "./settingsReducer";
import contentPage from "./contentPagesReducer";
import paymentGateway from "./apiManagement/paymentGatewayReducer";
import recaptcha from "./apiManagement/recaptchaReducer";
import social from "./apiManagement/socialSignupReducer";
import headerLang from "./languageSelector/languageSelector";
import revenue from "./revenue/revenueReducer";
import role from "./roleManagement/roleManagementReducer";
import meta from "./meta/metaReducer";
import taxonomy from "./taxonomy/taxonomyReducer";
import spamSetting from "./spamSetting/spamSettingReducer";
import dashboard from "./dashboard/dashboardReducer";
import campaign from "./campaigns/campaignsReducer";
import accreditation from "./accreditation/accreditationReducer";
import cf3Questionnaire from "./cf3Questionnaire/cf3QuestionnaireReducer";
import { issuerVerificationReducer as issuerVerification } from "./issuerVerification/issuerVerificationReducer";
import activity from "./activity/activityReducer";
import email from "./emailSettings/emailSettingsReducer";
import cron from "./cron/cronReducer";
import transaction from "./transactions/transactionReducer";
import newsletter from "./newsletters/newsletterReducer";
import exportAllCSV from "./exportCsv/exportCsvReducer";
import wallet from "./wallet/walletReducer";
import savedInvestment from "./savedInvestment/saveInvestmentReducer";
import userInvestment from "./userInvestment/userInvestmentReducer";
import mangopay from "./mangopay/mangopayReducer";
import notificationTemplates from "./notificationTemplates/notificationTemplatesReducer";
import secondaryMarket from "./secondaryMarket/secondaryMarketReducer";
import support from "./support/supportReducer";

const rootPersistConfig = {
  key: "root",
  storage: storage,
};
const rootReducer = combineReducers({
  auth: authReducer,
  adminAuth,
  categoryReducer,
  manageOptions,
  frontEndUsers,
  misc,
  countries,
  settings,
  contentPage,
  paymentGateway,
  recaptcha,
  social,
  headerLang,
  revenue,
  role,
  meta,
  taxonomy,
  spamSetting,
  dashboard,
  campaign,
  accreditation,
  cf3Questionnaire,
  issuerVerification,
  activity,
  email,
  cron,
  transaction,
  newsletter,
  exportAllCSV,
  wallet,
  savedInvestment,
  userInvestment,
  mangopay,
  notificationTemplates,
  secondaryMarket,
  support
});

export default persistReducer(rootPersistConfig, rootReducer);
